import StackableArea from 'components/Shared/StackedContent/StackableArea';
import { StackedArea, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { animated, config, useTransition } from 'react-spring';
import styled from 'styled-components';
import { breadcrumbUtils } from 'utils';
import { useActiveContext } from '../Context/ActiveContext';
import DesktopActivitySlide from '../Slides/DesktopActivitySlide';
import ImpactClaimSlide from '../Slides/DesktopImpactClaimsSlide';
import DetailedClaimSlide from '../Slides/DetailedClaimSlide';
import DesktopSiteOverviewSlide from '../Slides/DesktopSiteOverviewSlide';
import { ProductJourneyPages } from '../pages';
const Container = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 400px;
  background: #fff;
  overflow: hidden;

  .slide-transition {
    position: absolute;
    background: #fff;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }
`;
const SidebarSlideController = () => {
    const { activeStepActivity, steps, isIntegration, activeStepIndex } = useActiveContext();
    const { t } = useTranslation();
    const { activeStackedContent, activateStackedContent } = useStackableContent();
    const transitions = useTransition((activeStackedContent === null || activeStackedContent === void 0 ? void 0 : activeStackedContent.id) || 'overview', {
        initial: { opacity: 1, transform: 'translateY(0)' },
        from: { opacity: 0, transform: 'translateY(32px)' },
        enter: { opacity: 1, transform: 'translateY(0)' },
        leave: { opacity: 0 },
        config: config.default,
    });
    const openImpactClaimSlide = () => {
        activateStackedContent({
            renderComponent: () => (React.createElement(ImpactClaimSlide, { activity: activeStepActivity.activity, steps: steps, openImpactClaimDetailSlide: openImpactClaimDetailSlide })),
            id: ProductJourneyPages.IMPACT_CLAIM_LIST,
            area: StackedArea.SIDEBAR,
            isActive: true,
            layout: null,
            breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.IMPACT_CLAIM_LIST, t),
        });
    };
    const openImpactClaimDetailSlide = (claim) => {
        activateStackedContent({
            renderComponent: () => (React.createElement(DetailedClaimSlide, { impactClaim: claim, activity: activeStepActivity.activity, isIntegration: isIntegration })),
            id: ProductJourneyPages.IMPACT_CLAIM,
            area: StackedArea.SIDEBAR,
            isActive: true,
            layout: null,
            breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.IMPACT_CLAIM, t, claim.impactCatalogItem.title),
        });
    };
    const openActivitySitesClick = () => {
        activateStackedContent({
            renderComponent: () => (React.createElement(DesktopSiteOverviewSlide, { chainStepActivity: activeStepActivity })),
            id: ProductJourneyPages.SITE_CLUSTER_OVERVIEW,
            area: StackedArea.SIDEBAR,
            isActive: true,
            layout: null,
            breadcrumb: breadcrumbUtils.getBreadcrumb(ProductJourneyPages.SITE_CLUSTER_OVERVIEW, t, activeStepIndex !== 0 ? t('site') : undefined),
        });
    };
    return (React.createElement(Container, { className: "st-desktop-only" },
        React.createElement(StackableArea, { area: StackedArea.SIDEBAR }, transitions((styles, item, _, i) => {
            return (React.createElement(animated.div, { key: i, style: styles, className: "slide-transition" },
                React.createElement(DesktopActivitySlide, { onImpactClaimClick: openImpactClaimSlide, onActivitySitesClick: openActivitySitesClick })));
        }))));
};
export default SidebarSlideController;
